import { Box, Skeleton, styled, Typography } from "@mui/material";
import React from "react";

interface HeaderProps {
  children?: React.ReactNode;
  title?: string;
  icon?: React.ComponentType<any>;
  backgroundColor?: string;
  showSkeleton?: boolean;
}

const HeaderContainer = styled(Box)({
  height: "64px" /* Altura aumentada para melhor proporção */,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "0 20px" /* Padding aumentado */,
  borderBottom: "1px solid #e9edef",
  backgroundColor: "#f0f2f5",
  flexShrink: 0,
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.04)" /* Sombra sutil */,
  "@media (max-width: 600px)": {
    height: "64px" /* Manter altura consistente em mobile */,
    padding: "0 16px" /* Padding ajustado para mobile */,
  },
});

const Header: React.FC<HeaderProps> = ({
  children,
  title,
  icon: Icon,
  backgroundColor = "#f0f2f5",
  showSkeleton = false,
}) => {
  if (showSkeleton) {
    return (
      <HeaderContainer sx={{ backgroundColor }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Skeleton variant="circular" width={24} height={24} />
          <Skeleton variant="text" width={200} height={24} />
        </Box>
        <Box sx={{ display: "flex", gap: 1 }}>
          <Skeleton variant="circular" width={32} height={32} />
          <Skeleton variant="circular" width={32} height={32} />
        </Box>
      </HeaderContainer>
    );
  }

  return (
    <HeaderContainer sx={{ backgroundColor }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        {Icon && <Icon sx={{ color: "#54656f" }} />}
        {title && (
          <Typography
            variant="h6"
            sx={{
              color: "#111b21",
              fontWeight: 600 /* Peso aumentado para melhor hierarquia */,
              fontSize: "18px" /* Tamanho aumentado */,
              "@media (max-width: 600px)": {
                fontSize: "16px" /* Tamanho ajustado para mobile */,
              },
            }}
          >
            {title}
          </Typography>
        )}
      </Box>
      {children}
    </HeaderContainer>
  );
};

export default Header;
